import { stripHtml } from "@/utils/format";

interface HotelInfoProps {
  starLevel: string;
  name: string;
  address: string;
  rating: number | string;
  reviewCount: number | string;
  checkInTime: string;
  checkOutTime: string;
}

export default function HotelInfo({ starLevel, name, address, rating, reviewCount, checkInTime, checkOutTime }: HotelInfoProps) {
  return (
    <div className="bg-white px-5 py-4">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ background: "#FEF3C7", color: "#D97706" }}>{starLevel}</span>
          </div>
          <h1 className="text-xl font-bold text-gray-900 leading-snug">{name}</h1>
          <div className="flex items-center gap-1.5 mt-2">
            <i className="ri-map-pin-2-line" style={{ color: "#9CA3AF", fontSize: 13 }} />
            <span className="text-xs text-gray-500">{stripHtml(address)}</span>
          </div>
        </div>
        {/* 分享按钮：暂时隐藏，后期可能会用到
        <button className="flex items-center justify-center w-9 h-9 rounded-full flex-shrink-0 cursor-pointer" style={{ background: "#F3F4F6" }}>
          <i className="ri-share-forward-line" style={{ color: "#6B7280", fontSize: 18 }} />
        </button>
        */}
      </div>

      {/* 评分 + 入退房时间 */}
      <div className="flex items-center gap-4 mt-3 pt-3 border-t border-gray-100">
        <div className="flex items-center gap-1.5">
          <div className="w-9 h-9 flex items-center justify-center rounded-xl text-white font-bold text-sm" style={{ background: "#F97316" }}>
            {rating}
          </div>
          <div>
            <div className="text-sm font-semibold text-gray-800">评分极高</div>
            <div className="text-xs text-gray-400">{reviewCount}条真实评价</div>
          </div>
        </div>
        <div className="flex-1" />
        <div className="text-right">
          <div className="text-xs text-gray-400">入住 {checkInTime} | 退房 {checkOutTime}</div>
        </div>
      </div>
    </div>
  );
}
